import { Card, Col, Input, Pagination, Row, Select, Spin, Table, Modal, Button, Steps } from "antd";
import { Option } from "antd/es/mentions";
import { LoadingOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import { LIST_CAMPAIGN_USER, LIST_DEPARTMENTS } from "../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";

const { Step } = Steps;

function CampaignUsers(props) {
  const { campaign_id, filterStatus, setLoadingUsers } = props;
  const [page_size, set_page_size] = useState(10);

  // State variables
  const [loader, setLoader] = useState(true); // initial page loader
  const [pagination_loader, set_pagination_loader] = useState(false); // loader for pagination/search actions
  const [table_data, set_table_data] = useState(false);
  const [current_page, set_current_page] = useState("");
  const [total_pages, set_total_pages] = useState("");
  const [total_users, set_total_users] = useState("");

  // Search states (separated for clarity)
  const [emailValue, setEmailValue] = useState("");
  const [statusValue, setStatusValue] = useState(""); // will hold numeric string like "0","1",...

  // Modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [departmentList, setDepartmentList] = useState([]);
  const [departmentValue, setDepartmentValue] = useState("");

  const handleDepartmentChange = (val) => {
    setDepartmentValue(val);
    setStatusValue("");
    setEmailValue("");

    const FORM_DATA = new FormData();
    FORM_DATA.append("campaign_id", campaign_id);

    if (val) {
      FORM_DATA.append("department", val); // 👈 string value
    }

    fetchResultsDebounced(FORM_DATA);
  };
  // ================= GET DEPARTMENTS =================
  useEffect(() => {
    const GET_DEPARTMENTS = async () => {
      try {
        const FORM_DATA = new FormData();
        FORM_DATA.append("campaign_id", campaign_id);

        const res = await LIST_DEPARTMENTS(FORM_DATA);

        if (res?.data?.status) {
          setDepartmentList(res.data.data || []);
        }
      } catch (err) {
        console.error("Department API Error:", err);
      }
    };

    GET_DEPARTMENTS();
  }, [campaign_id]);

  const showModal = (record) => {
    setSelectedUser(record);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const STATUS_OPTIONS = [
    // { label: "All ", value: "all" },
    { label: " Sent", value: "1" },
    { label: "Opened", value: "2" },
    { label: "Clicked ", value: "3" },
    { label: "Submitted ", value: "4" },
    { label: "Reported ", value: "5" }
  ];

  // unified fetch function (used by debounce wrapper)
  const fetchResultsDebounced = useCallback(
    debounce(async (formData) => {
      try {
        set_pagination_loader(true);
        const API_CALL = await LIST_CAMPAIGN_USER(formData);
        if (API_CALL?.data?.status) {
          set_table_data(API_CALL?.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_users(API_CALL?.data?.total_users);
        } else {
          set_table_data([]);
        }
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        set_pagination_loader(false);
        // ensure parent loader also turned off if it was set by chart click
        if (typeof setLoadingUsers === "function") setLoadingUsers(false);
      }
    }, 500),
    [campaign_id]
  );

  // wrapper to call the debounced fetch with key/value
  const fetchResults = (search_key, search_value) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("campaign_id", campaign_id);
    if (search_key && search_value !== undefined && search_value !== null && search_value !== "") {
      // if key is status and value is number 0.. then append as number
      FORM_DATA.append(search_key, search_value);
    }
    fetchResultsDebounced(FORM_DATA);
  };

  // initial load
  useEffect(() => {
    const LIST_API = async () => {
      setLoader(true);
      try {
        const FORM_DATA = new FormData();
        FORM_DATA.append("campaign_id", campaign_id);
        const API_CALL = await LIST_CAMPAIGN_USER(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_table_data(API_CALL?.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_users(API_CALL?.data?.total_users);
        } else {
          set_table_data([]);
        }
      } catch (err) {
        console.error("LIST_API Error:", err);
      } finally {
        setLoader(false);
      }
    };

    LIST_API();
  }, [campaign_id]);


  useEffect(() => {
    if (filterStatus !== "" && filterStatus !== null && filterStatus !== undefined) {

      setEmailValue("");
      setStatusValue(filterStatus);

      (async () => {
        if (typeof setLoadingUsers === "function") setLoadingUsers(true);
        set_pagination_loader(true);
        try {
          const FORM_DATA = new FormData();
          FORM_DATA.append("campaign_id", campaign_id);
          FORM_DATA.append("status", Number(filterStatus));
          const API_CALL = await LIST_CAMPAIGN_USER(FORM_DATA);
          if (API_CALL?.data?.status) {
            set_table_data(API_CALL?.data?.data);
            set_current_page(API_CALL?.data?.current_page);
            set_total_pages(API_CALL?.data?.total_pages);
            set_total_users(API_CALL?.data?.total_users);
          } else {
            set_table_data([]);
          }
        } catch (err) {
          console.error("Filter API Error:", err);
        } finally {
          set_pagination_loader(false);
          if (typeof setLoadingUsers === "function") setLoadingUsers(false);
        }
      })();
    }
  }, [filterStatus, campaign_id, setLoadingUsers]);

  const selectBefore = (
    <Select
      defaultValue="email"
      style={{ width: 80 }}
    >
      <Option value="email">Email</Option>
    </Select>
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (_, record) => <span>{record.name}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (_, record) => <span>{record.email}</span>,
    },
    {
      title: "Phone",
      dataIndex: "contact_no",
      render: (_, record) => <span>{record.contact_no || "No Data"}</span>,
    },
    {
      title: "Department",
      dataIndex: "department",
      render: (val) => {
        if (
          val === null ||
          val === undefined ||
          val === "" ||
          val === "null" ||
          val === "NaN" ||
          val === "nan"
        ) {
          return "Unassigned";
        }

        return val;
      },
    },
    {
      title: "Status",
      render: (_, record) => (
        <>
          {record?.tracking_data?.tracking_status === 0 && (
            <span style={{ color: "#8c3add" }}>Email Sent</span>
          )}
          {record?.tracking_data?.tracking_status === 1 && (
            <span style={{ color: "#1fa7a1" }}>Email Opened</span>
          )}
          {record?.tracking_data?.tracking_status === 2 && (
            <span style={{ color: "#eab451" }}>Clicked Link</span>
          )}
          {record?.tracking_data?.tracking_status === 3 && (
            <span style={{ color: "#b37feb" }}>Submitted Data</span>
          )}
          {record?.tracking_data?.tracking_status === 4 && (
            <span style={{ color: "#5B8DEF" }}>Reported Email</span>
          )}
          {record?.tracking_data?.tracking_status === 200 && (
            <span style={{ color: "#f97d7d" }}>Spam Email</span>
          )}
          {record?.tracking_data?.tracking_status === 522 && (
            <span style={{ color: "#f97d7d" }}>Spam + Copyright</span>
          )}
          {record?.tracking_data?.tracking_status === 523 && (
            <span style={{ color: "#ad3a05ff" }}>Bot Detection</span>
          )}
        </>
      ),
    },
    {
      title: "Button Details",
      render: (_, record) => (
        record?.tracking_data?.meta_details?.clicked_buttons?.length > 0 ? (
          record.tracking_data.meta_details.clicked_buttons.map((btn, index) => (
            <Button key={index} size="small" style={{ marginRight: 4 }}>
              {btn.replace(/[-_]/g, " ")}
            </Button>
          ))
        ) : (
          <span style={{ color: "#999" }}>Empty</span>
        )
      )
    },

    {
  title: "Attachment",
  render: (_, record) => {
    const attachment =
      record?.tracking_data?.meta_details?.attachment;

    // Attachment data nahi hai
     if (!attachment || !attachment.path) {
      return (
        <span
          style={{
            color: "#999",
            background: "#f5f5f5",
            border: "1px solid #d9d9d9",
            borderRadius: "15px",
            padding: "5px 12px",
            fontSize: "12px",
            whiteSpace: "nowrap",
          }}
        >
          No Attachment
        </span>
      );
    }

    // Downloaded
    if (attachment.downloaded === true) {
      return (
        <span
          style={{
            color: "#00a88f",
            background: "#e8fffa",
            border: "1px solid #b7eee5",
            borderRadius: "15px",
            padding: "5px 12px",
            fontSize: "12px",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
           Downloaded
        </span>
      );
    }

    // Opened / Accessed
    if (
      attachment.clicked === true ||
      attachment.accessed === true
    ) {
      return (
        <span
          style={{
            color: "#722ed1",
            background: "#f5eaff",
            border: "1px solid #e0c7ff",
            borderRadius: "15px",
            padding: "5px 12px",
            fontSize: "12px",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
           Opened
        </span>
      );
    }

    // Attachment exists but not opened
    return (
      <span
        style={{
          color: "#faad14",
          background: "#fff7e6",
          border: "1px solid #ffe0a3",
          borderRadius: "15px",
          padding: "5px 12px",
          fontSize: "12px",
          fontWeight: 500,
          whiteSpace: "nowrap",
        }}
      >
         Not Opened
      </span>
    );
  },
},
    {
      title: "Action",
      render: (_, record) => (
        <Button type="link" onClick={() => showModal(record)}>
          Details
        </Button>
      ),
    },
  ];

  const pagination_on_change = async (page, size = page_size) => {
    set_pagination_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("campaign_id", campaign_id);
      FORM_DATA.append("page", page);
      FORM_DATA.append("page_size", size);

      if (departmentValue) {
        FORM_DATA.append("department", departmentValue);
      }

      if (statusValue && statusValue !== "" && statusValue !== "all") {
        FORM_DATA.append("status", Number(statusValue));
      } else if (emailValue) {
        FORM_DATA.append("email", emailValue);
      }

      const API_CALL = await LIST_CAMPAIGN_USER(FORM_DATA);

      if (API_CALL?.data?.status) {
        set_table_data(API_CALL.data.data);
        set_current_page(API_CALL.data.current_page);
        set_total_pages(API_CALL.data.total_pages);
        set_total_users(API_CALL.data.total_users);
      } else {
        set_table_data([]);
      }
    } catch (err) {
      console.error("Pagination API Error:", err);
    } finally {
      set_pagination_loader(false);
      if (typeof setLoadingUsers === "function") setLoadingUsers(false);
    }
  };


  const handleInput = (e) => {
    const value = e.target.value;
    setEmailValue(value);

    if (statusValue !== "") {
      setStatusValue("");
    }

    // use the debounced fetchResults wrapper
    const FORM_DATA = new FormData();
    FORM_DATA.append("campaign_id", campaign_id);
    FORM_DATA.append("email", value);
    fetchResultsDebounced(FORM_DATA);
  };

  const handleStatusChange = (val) => {
    setStatusValue(val);

    const FORM_DATA = new FormData();
    FORM_DATA.append("campaign_id", campaign_id);

    if (!val) {
      setEmailValue("");
      fetchResultsDebounced(FORM_DATA);
      return;
    }

    FORM_DATA.append("status", Number(val));
    fetchResultsDebounced(FORM_DATA);
  };

  return (
    <Card>
      <Row gutter={16} style={{ marginBottom: 12 }}>
        <Col span={12}>
          <h2>Campaign User List</h2>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginBottom: 12, justifyContent: "space-between" }}>
        <Col span={12}>
          <Input
            addonBefore={selectBefore}
            style={{ width: "100%" }}
            placeholder="Search by email"
            value={emailValue}
            onChange={handleInput}
            size="large"
            allowClear
          />
        </Col>

        <Col span={10} style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>

          {/* Department Filter */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "16px", fontWeight: 500 }}>Department:</span>
            <Select
              showSearch
              allowClear
              placeholder="Select Department"
              style={{ width: 180 }}
              value={departmentValue || undefined}
              optionFilterProp="children"
              onChange={handleDepartmentChange}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {departmentList.map((dep, index) => (
                <Option key={index} value={dep}>
                  {dep}
                </Option>
              ))}
            </Select>
          </div>

          {/* Status Filter (unchanged) */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "16px", fontWeight: 500 }}>Status:</span>
            <Select
              placeholder="Filter by status"
              style={{ flex: 1, width: "110px" }}
              size="middle"
              allowClear
              value={statusValue === "" ? undefined : statusValue}
              onChange={handleStatusChange}
              options={STATUS_OPTIONS.map((s) => ({ label: s.label, value: s.value }))}
            />
          </div>
        </Col>
      </Row>


      {loader ? (
        <CulsightPageLoader />
      ) : pagination_loader ? (
        <div style={{ textAlign: "center", padding: "60px" }}>
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        </div>
      ) : (
        <>
          <Table
            columns={columns}
            pagination={false}
            dataSource={table_data || []}
            style={{ marginTop: "15px" }}
            rowKey={(record) => record.email}
          />

          {total_pages > 0 && (
            <div style={{ float: "right", marginTop: "20px" }}>
              <Pagination
                current={current_page}
                total={total_users}
                pageSize={page_size}
                showSizeChanger
                pageSizeOptions={['10', '20', '50', '100']}
                onShowSizeChange={(page, size) => {
                  set_page_size(size);
                  set_current_page(1);
                  pagination_on_change(1, size);
                }}
                onChange={(page) => {
                  pagination_on_change(page, page_size);
                }}
                style={{ display: "inline-block" }}
                className="no-search-pagination"
              />
              <style>
                {`
      .no-search-pagination .ant-select-selection-search-input {
        display: none !important;
      }
    `}
              </style>
            </div>
          )}
        </>
      )}

      {/* Modal with Steps */}
     <Modal
  title="User Details"
  open={isModalOpen}
  onCancel={handleCancel}
  footer={null}
>
 {selectedUser && (() => {
  const meta = selectedUser?.tracking_data?.meta_details || {};

  const hasOpen   = meta?.email_open_logs?.length > 0;
  const hasClick  = meta?.clicked_logs?.length > 0;
  const hasSubmit = selectedUser?.tracking_data?.form_submit != null &&
                    Object.keys(selectedUser.tracking_data.form_submit).length > 0;
  
                    
                    const attachment = meta?.attachment || {};
                    const hasReport = meta?.reported_logs?.length > 0;

const hasAttachment =
  Object.keys(attachment).length > 0;

const attachmentOpened =
  attachment?.clicked === true ||
  attachment?.accessed === true;

const attachmentDownloaded =
  attachment?.downloaded === true;

const attachmentOpenedAt =
  attachment?.clicked_at ||
  attachment?.accessed_at;

const attachmentDownloadedAt =
  attachment?.downloaded_at;

  // Last completed step dhundo
  const lastDone = hasReport ? 5
                 : hasSubmit ? 4
                 : hasClick  ? 3
                 : hasOpen   ? 2
                 : 1;

  // Helper — step reached hua ya nahi
  const isReached = (step) => step <= lastDone;

return (
  <>
    <Steps direction="vertical">

      {/* Step 1 */}
      <Step
        status="finish"
        title="Email Sent"
        description="User received the email."
      />

      {/* Step 2 */}
      <Step
        status={hasOpen ? "finish" : "wait"}
        title="Email Opened"
        description={
          hasOpen ? (
            <>
              <div style={{ fontWeight: 600, marginBottom: 6 }}>
                User opened the email.
              </div>

              {meta.email_open_logs.map((log, index) => (
                <div
                  key={index}
                  style={{
                    padding: "6px 10px",
                    borderRadius: "6px",
                    marginBottom: "6px",
                    fontSize: "12px",
                    background: "#f5f5f5"
                  }}
                >
                  <div>
                    <b>IP & Browser:</b> {log.apl_logs}
                  </div>
                  <div>
                    <b>Time:</b> {log.timespamp}
                  </div>
                </div>
              ))}
            </>
          ) : (
            <span style={{ color: "#999" }}>Remain</span>
          )
        }
      />

      {/* Step 3 */}
      <Step
        status={hasClick ? "finish" : "wait"}
        title="Clicked Link"
        description={
          hasClick ? (
            <>
              <div style={{ fontWeight: 600, marginBottom: 6 }}>
                User clicked the link.
              </div>

              {meta.clicked_logs.map((log, index) => (
                <div
                  key={index}
                  style={{
                    padding: "6px 10px",
                    borderRadius: "6px",
                    marginBottom: "6px",
                    fontSize: "12px",
                    background: "#f5f5f5"
                  }}
                >
                  <div>
                    <b>IP & Browser:</b> {log.apl_logs}
                  </div>
                  <div>
                    <b>Time:</b> {log.timespamp}
                  </div>
                </div>
              ))}
            </>
          ) : (
            <span style={{ color: "#999" }}>Remain</span>
          )
        }
      />

      {/* Step 4 */}
      <Step
        status={hasSubmit ? "finish" : "wait"}
        title="Submitted Data"
        description={
          hasSubmit ? (
            <>
              <div style={{ fontWeight: 600, marginBottom: 6 }}>
                User submitted data.
              </div>

              {Object.entries(
                selectedUser.tracking_data.form_submit
              ).map(([key, value], index) => (
                <div key={index}>
                  <b
                    style={{
                      color: "#ff9696",
                      textTransform: "capitalize",
                      fontSize: "12px"
                    }}
                  >
                    {key}
                  </b>{" "}
                  ={" "}
                  <b
                    style={{
                      color: "#7be1d1",
                      textTransform: "capitalize",
                      fontSize: "12px"
                    }}
                  >
                    {value}
                  </b>
                </div>
              ))}
            </>
          ) : (
            <span style={{ color: "#999" }}>Remain</span>
          )
        }
      />

      {/* Step 5 */}
      <Step
        status={hasReport ? "finish" : "wait"}
        title="Reported Email"
        description={
          hasReport ? (
            <>
              <div
                style={{
                  color: "#5B8DEF",
                  fontWeight: 600,
                  marginBottom: 6
                }}
              >
                User reported this email.
              </div>

              {meta.reported_logs.map((log, index) => (
                <div
                  key={index}
                  style={{
                    padding: "6px 10px",
                    borderRadius: "6px",
                    marginBottom: "6px",
                    fontSize: "12px",
                    background: "#f5f5f5"
                  }}
                >
                  <div><b>IP:</b> {log?.apl_logs?.ip}</div>
                  <div><b>Source:</b> {log?.apl_logs?.source}</div>
                  <div><b>User Agent:</b> {log?.apl_logs?.user_agent}</div>
                  <div><b>Reported At:</b> {log?.apl_logs?.reported_at}</div>
                  <div><b>Time:</b> {log?.timespamp}</div>
                </div>
              ))}
            </>
          ) : (
            <span style={{ color: "#999" }}>Remain</span>
          )
        }
      />

    </Steps>

    {/* ================= ATTACHMENT ACTIVITY ================= */}

    {hasAttachment && (
      <div
        style={{
          marginTop: "16px",
          paddingTop: "16px",
          borderTop: "1px solid #f0f0f0"
        }}
      >
        {/* YAHAN TUMHARA PURA EXISTING
            ATTACHMENT ACTIVITY CODE RAHEGA */}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "14px"
          }}
        >
          <span style={{ fontSize: "18px", color: "#722ed1" }}>
            📎
          </span>

          <span
            style={{
              fontSize: "15px",
              fontWeight: 600,
              color: "#1f1f1f"
            }}
          >
            Attachment Activity
          </span>
        </div>

        <div
          style={{
            fontSize: "12px",
            color: "#555",
            marginBottom: "16px"
          }}
        >
          File:{" "}
          <b style={{ color: "#333" }}>
            {attachment?.filename || "Attachment"}
          </b>
        </div>

        {/* Attachment Opened */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
            marginBottom: "14px"
          }}
        >
          <span
            style={{
              width: "22px",
              height: "22px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: attachmentOpened ? "#d9f7f0" : "#f5f5f5",
              color: attachmentOpened ? "#00a88f" : "#999",
              fontWeight: 600,
              flexShrink: 0
            }}
          >
            {attachmentOpened ? "✓" : "−"}
          </span>

          <div>
            <div
              style={{
                fontSize: "13px",
                fontWeight: 600,
                color: attachmentOpened ? "#00a88f" : "#999"
              }}
            >
              {attachmentOpened
                ? "Attachment Opened"
                : "Attachment Not Opened"}
            </div>

            {attachmentOpened && attachmentOpenedAt && (
              <div
                style={{
                  fontSize: "12px",
                  color: "#777",
                  marginTop: "4px"
                }}
              >
                Opened At:{" "}
                {new Date(attachmentOpenedAt).toLocaleString("en-IN", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: true
                })}
              </div>
            )}
          </div>
        </div>

        {/* Attachment Downloaded */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "10px"
          }}
        >
          <span
            style={{
              width: "22px",
              height: "22px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: attachmentDownloaded ? "#d9f7f0" : "#f5f5f5",
              color: attachmentDownloaded ? "#00a88f" : "#999",
              fontWeight: 600,
              flexShrink: 0
            }}
          >
            {attachmentDownloaded ? "✓" : "−"}
          </span>

          <div>
            <div
              style={{
                fontSize: "13px",
                fontWeight: 600,
                color: attachmentDownloaded ? "#00a88f" : "#999"
              }}
            >
              {attachmentDownloaded
                ? "Attachment Downloaded"
                : "Attachment Not Downloaded"}
            </div>

            {attachmentDownloaded && attachmentDownloadedAt && (
              <div
                style={{
                  fontSize: "12px",
                  color: "#777",
                  marginTop: "4px"
                }}
              >
                Downloaded At:{" "}
                {new Date(attachmentDownloadedAt).toLocaleString("en-IN", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: true
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    )}

  </>
);
})()}
</Modal>
    </Card>
  );
}

export default CampaignUsers;
